import React from 'react';

import DateField from 'components/formInputs/DateField';
import SelectField from 'components/formInputs/SelectField';
import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import ShowHide from 'components/ShowHide';
import { Gender } from 'types/graph';

import { a1cRangeOptions, diabetesTypeChoices, insulinUnitsOptions, LABELS } from './constants';
import { DiabetesFormProps } from './types';

const DiabetesForm: React.FC<DiabetesFormProps> = ({
  gender,
  handleSubmit,
  invalid,
  submitting,
  values,
}) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <DateField name="diagnosedAt" label={LABELS.diagnosedAt} />
    <ToggleField
      name="diabetesType"
      groupLabel={LABELS.diabetesType}
      choices={diabetesTypeChoices}
    />
    <ShowHide visible={values.diabetesType === 2 && gender === Gender.Female}>
      <ToggleField name="gestational" groupLabel={LABELS.gestational} />
    </ShowHide>
    <SelectField name="lastA1cReading" label={LABELS.lastA1cReading} options={a1cRangeOptions} />
    <SelectField
      name="twelveMonthAverageA1cReading"
      label={LABELS.twelveMonthAverageA1cReading}
      options={a1cRangeOptions}
    />
    <ToggleField name="hasHadComplications" groupLabel={LABELS.hasHadComplications} />
    <ToggleField name="currentlyTreated" groupLabel={LABELS.currentlyTreated} />
    <ShowHide visible={values.currentlyTreated === false}>
      <DateField name="lastTreatmentDate" label={LABELS.lastTreatmentDate} />
    </ShowHide>
    <SelectField name="insulinUnits" label={LABELS.insulinUnits} options={insulinUnitsOptions} />
  </FormWrapper>
);

export default DiabetesForm;
